import { COLORS } from '@shared/config/colors/colors';
import { Button } from '@vtbhome/juicyfront';
import { styled } from 'goober';

export const StyledButton = styled(Button)`
    .preloader {
        color: ${COLORS.neutral_50} !important;
    }
`;
